export default __webpack_public_path__ + "static/media/ourvision.361608f8.png";